module.exports = __webpack_public_path__ + "img/sad.5aa0f8d6.png";